import { useParams, useNavigate } from "react-router-dom";
import AssessmentScreen from "@/components/assessments/AssessmentScreen";

const AssessmentPage = () => {
  const { assessmentId } = useParams<{ assessmentId: string }>();
  const navigate = useNavigate();

  if (!assessmentId) {
    navigate("/dashboard");
    return null;
  }

  return (
    <AssessmentScreen
      assessmentId={assessmentId}
      onComplete={() => navigate(-1)}
      onBack={() => navigate(-1)}
    />
  );
};

export default AssessmentPage;
